var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion", class: { "accordion--open": _vm.isOpen } },
    [
      _c(
        "div",
        {
          staticClass: "accordion__titlebar",
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _c("div", { staticClass: "accordion__title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "accordion__close",
              class: { "accordion__close--open": _vm.isOpen },
              attrs: {
                width: "18",
                height: "11",
                viewBox: "0 0 18 11",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d:
                    "M1.17208 1.02429C1.7579 0.438544 2.70765 0.438607 3.2934 1.02443L9.14688 6.87869L15.0022 1.02428C15.588 0.43854 16.5377 0.438611 17.1235 1.02444C17.7092 1.61027 17.7092 2.56002 17.1233 3.14576L10.2073 10.0607C9.62148 10.6465 8.67174 10.6464 8.086 10.0606L1.17194 3.14561C0.586188 2.55979 0.586251 1.61004 1.17208 1.02429Z",
                  fill: "#FF8000"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("VueSlideToggle", { attrs: { open: _vm.isOpen } }, [
        _c("div", { staticClass: "accordion__content" }, [_vm._t("default")], 2)
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }